// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2CvGD","right":"Footer_right__39-jb","buttons":"Footer_buttons__2olVN"};